import { render } from "./AdminReportDetails.vue?vue&type=template&id=08345db2&scoped=true"
import script from "./AdminReportDetails.vue?vue&type=script&lang=js"
export * from "./AdminReportDetails.vue?vue&type=script&lang=js"

import "./AdminReportDetails.vue?vue&type=style&index=0&id=08345db2&scoped=true&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08345db2"]])

export default __exports__